(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    // A ratio threshold (e.g. 0.1) never fires for elements taller than
    // 10x the viewport, leaving them stuck at opacity 0. Reveal as soon as any
    // part enters the viewport instead, minus a small bottom offset.
    { threshold: 0, rootMargin: '0px 0px -10% 0px' }
  );

  function observe(root) {
    root.querySelectorAll('[data-animate]').forEach(function (el) {
      observer.observe(el);
    });
  }

  observe(document);

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
